"use strict";
exports.__esModule = true;
var common_1 = require("./common");
exports.Type = common_1.Type;
exports.SectionId = common_1.SectionId;
exports.ExternalKind = common_1.ExternalKind;
/** Cached compiled parser. */
var compiled = null;
if (typeof WASM_DATA !== "string")
    WASM_DATA = require("fs").readFileSync(__dirname + "/../build/index.wasm", "base64");
/** Parses the contents of a WebAssembly binary according to the specified options. */
function parse(binary, options) {
    if (!options)
        options = {};
    // compile the parser if not yet compiled
    if (!compiled)
        compiled = new WebAssembly.Module(base64_decode(WASM_DATA));
    // use the binary as the parser's memory
    var nBytes = binary.length;
    var nPages = ((nBytes + 0xffff) & ~0xffff) >> 16;
    var memory = new WebAssembly.Memory({ initial: nPages });
    var buffer = new Uint8Array(memory.buffer);
    buffer.set(binary);
    // provide a way to read strings from memory
    parse.readString = function (offset, length) { return utf8_read(buffer, offset, offset + length); };
    // instantiate the parser and return its exports
    var imports = {
        env: {
            memory: memory
        },
        options: {}
    };
    ["onSection",
        "onType",
        "onTypeParam",
        "onTypeReturn",
        "onImport",
        "onFunctionImport",
        "onTableImport",
        "onMemoryImport",
        "onGlobalImport",
        "onMemory",
        "onFunction",
        "onTable",
        "onGlobal",
        "onExport",
        "onStart",
        "onSourceMappingURL",
        "onModuleName",
        "onFunctionName",
        "onLocalName"
    ].forEach(function (name) { return imports.options[name] = options[name] || function () { }; });
    var instance = new WebAssembly.Instance(compiled, imports);
    instance.exports.parse(0, nBytes);
}
exports.parse = parse;
// see: https://github.com/dcodeIO/protobuf.js/tree/master/lib/utf8
function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1)
        return "";
    var parts = null, chunk = [], i = 0, // char offset
    t = 0; // temporary
    while (start < end) {
        t = buffer[start++];
        if (t < 128) {
            chunk[i++] = t;
        }
        else if (t > 191 && t < 224) {
            chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        }
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        }
        else {
            chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i)
            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
}
// see: https://github.com/dcodeIO/protobuf.js/tree/master/lib/base64
function base64_decode(string) {
    var length = string.length;
    if (length) {
        var n = 0, p = length;
        while (--p % 4 > 1 && string.charCodeAt(p) === 61)
            ++n;
        length = Math.ceil(length * 3) / 4 - n;
    }
    var buffer = new Uint8Array(length);
    var j = 0, o = 0, t = 0;
    for (var i = 0, k = string.length; i < k;) {
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1)
            break;
        if ((c = s64[c]) === undefined)
            throw Error();
        switch (j) {
            case 0: {
                t = c;
                j = 1;
                break;
            }
            case 1: {
                buffer[o++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            }
            case 2: {
                buffer[o++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            }
            case 3: {
                buffer[o++] = (t & 3) << 6 | c;
                j = 0;
                break;
            }
        }
    }
    if (j === 1)
        throw Error();
    return buffer;
}
var s64 = new Array(123);
for (var i = 0; i < 64;)
    s64[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
